import { ENDPOINTS } from "./apiEndponts";

export const loginUser = async (email, password) => {
  try {
    const response = await fetch(ENDPOINTS.LOGIN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return { token: data.access, email };
  } catch (error) {
    console.error("Error en loginUser:", error);
    throw new Error(error.message);
  }
};

export const saveToken = ({ token, email }) => {
  const now = new Date();
  const expirationTime = now.getTime() + 30 * 60 * 1000;
  localStorage.setItem("auth", JSON.stringify({ email, token }));
  localStorage.setItem("session_expiration", expirationTime);
};

export const isTokenValid = () => {
  const expiration = localStorage.getItem("session_expiration");

  if (!expiration) return false;

  return new Date().getTime() < Number(expiration);
};

export const getAuth = () => {
  const authData = localStorage.getItem("auth");
  return authData ? JSON.parse(authData) : null;
};

export const logout = () => {
  localStorage.removeItem("auth");
  localStorage.removeItem("session_expiration");
};
